<template>
  <Info>
    Please request access
    <a href="https://knowledge.geospark.io/hyperion-7-day-free-trial">here</a>
  </Info>
</template>

<script>
export default {
  name: "RegistrationTokenMissing",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
